import React from "react";
import { connect } from "react-redux";

import { TimeSelect } from "../components/timeselect";
import {
	IcLocationSearch,
	IcBack,
	IcCalendarSearch,
} from "../../common/svg";



class CSSearchScreen extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isCalendar: false,
		};
	}


	toggleSelectTimeCS = () => {
		this.props.toggleSelectTimeCS();
	};

	onSelectTimeCSChange = (e) => {
		this.props.onSelectTimeCSChange(e);
	};


	hide = () => {
		this.props.hide();
	};


	render() {
		const {
			isShow,
			wrapperRef,
            isSelectTimeCS
		} = this.props;

		const { address, timeCS } = this.props.csFinding.filter;


		return (
			<div className={`finding-toggle ${isShow ? "" : "move-left"}`}>
				<div className="m-container" id="home-box">
					<div className="toggle-header">
						<div className="space" />
						<h6>Tìm kiếm</h6>
						<div className="back" onClick={() => this.hide()}>
							×
						</div>
					</div>
					<div className="toggle-footer">
						<a className="btn btn--s btn-primary" onClick={() => this.hide()}>
							Tìm xe ngay
						</a>
					</div>

                    <div className="search-option">
						<TimeSelect id={'mTsCF'} timeCS={timeCS} isSelectTimeCS={isSelectTimeCS} wrapperCSSelect={wrapperRef} toggleSelectTimeCS={this.toggleSelectTimeCS} onSelectTimeCSChange={this.onSelectTimeCSChange} cd={true} />
					</div>

					
							{/* <div className="group-item has-arrow">
								<div className="title">
									<div className="wrap-svg">
										<IcLocationSearch />
									</div>
									<p>Địa điểm</p>
								</div>
							
                                <div className="here-autocomplete">
                                    <p className={`address pointer`}>
                                        {address}
                                    </p>
                                </div>
							</div>
							<div className="line-page" />

							<div className="calendar-wrap" >
								<div className="group-item has-arrow">
									<div className="title">
										<div className="wrap-svg">
											<IcCalendarSearch />
										</div>
										<p>Thời gian thuê</p>
									</div>
									<p className="value">
                                        <p className="select">{timeCS == 12 ? `${timeCS} năm` : timeCS == 0 ? 'Tùy chỉnh' : `${timeCS} tháng`}</p>
									</p>
								</div>
							</div> */}

						
					
				</div>
			</div>
		);
	}
}

function mapState(state) {
	return {
		csFinding: state.csFinding,
	};
}

CSSearchScreen = connect(mapState)(CSSearchScreen);

export default CSSearchScreen;
